module.exports = __webpack_public_path__ + "static/media/heycar_2.b8543513.png";